// extracted by mini-css-extract-plugin
export default {"text-content-display":"textContentDisplay_text-content-display__aDy5u","editor":"textContentDisplay_editor__Su0iK"};